
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo: { title: 'IFEA Treuhand' },

    extends: View,

    mixins: [
      LoadSections([
        'hero',
        'ifea-info',
        'features',
        // 'team',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
